import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BoxLoading } from "react-loadingg";
import {
  ContentfulClient,
  ContentfulClientInterface,
  ContentfulProvider,
} from "react-contentful";

import reportWebVitals from "./reportWebVitals";
import Application from "./components/Application";

import {
  HomePage,
  CareerPage,
  ProductPage,
  CareerDetailPage,
  TeamPage,
} from "src/pages";
import { CreateClientParams } from "contentful";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";
import TermsOfUsePage from "./pages/TermsOfUse";

const FallbackComponent = () => {
  return (
    <div className="loading">
      <BoxLoading size="large" color="rgb(228, 69, 37)" />
    </div>
  );
};

const option: CreateClientParams = {
  accessToken: "ShSx-Qm9wT6YENaHA3KJHo7lbC6bJUyvXIhfGi3WxMs",
  space: "1fwym3u5yr4h",
};

// @ts-ignore
const contentfulClient: ContentfulClientInterface = new ContentfulClient(
  option
);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ContentfulProvider client={contentfulClient}>
        <Application>
          <Suspense fallback={<FallbackComponent />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/career" element={<CareerPage />} />
              <Route path="/career/:id" element={<CareerDetailPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/privacy-policy.html"></Route>
              <Route path="/terms-of-use.html"></Route>
              <Route path="/term-of-use.html"></Route>
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-of-use" element={<TermsOfUsePage />} />
              <Route path="/term-of-use" element={<TermsOfUsePage />} />

              <Route path="/product" element={<ProductPage />} />
            </Routes>
          </Suspense>
        </Application>
      </ContentfulProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
